import { render, staticRenderFns } from "./AdvertisementModal.vue?vue&type=template&id=6582d88c&scoped=true"
import script from "./AdvertisementModal.vue?vue&type=script&lang=js"
export * from "./AdvertisementModal.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementModal.vue?vue&type=style&index=0&id=6582d88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582d88c",
  null
  
)

export default component.exports